<!-- Simple split button  -->
<p-splitButton
  #splitOptions
  [label]="currentValue?.label"
  appendTo="body"
  [model]="splitMenuItems"
  class="bfx-dropdown-button"
  [styleClass]="buttonClass"
  menuStyleClass="bfx-dashboard-menu"
  (onClick)="showMenu()"
>
</p-splitButton>
